export default "__VITE_ASSET__6QTsdabG__"